  export class DFCountryCarrierList {
    public id: string;
    public country: string;
    public countryCode: string;
    public carrier: DFCarrier[];
    public fixedChargeFrequency: string;
    public initialVoucherCharge: number;

    static fromDto(d: any): DFCountryCarrierList {
      if (!d) {
        return null;
      }

      const dfcarrier = new DFCountryCarrierList();

      dfcarrier.id                = d.id;
      dfcarrier.country           = d.country;
      dfcarrier.countryCode       = d.country_code;
      dfcarrier.carrier           = d.carrier;
      dfcarrier.fixedChargeFrequency = d.fixed_charge_frequency;
      dfcarrier.initialVoucherCharge = d.initial_voucher_charge;

      return dfcarrier;
    }

    static toDto(r: DFCountryCarrierList): any {
      if (!r) {
        return null;
      }

      return {
        id: r.id,
        country: r.country,
        country_code: r.countryCode,
        carrier: r.carrier,
        fixed_charge_frequency: r.fixedChargeFrequency,
        initial_voucher_charge: r.initialVoucherCharge
      };
    }
  }

  export class DFCountry {
    id: string;
    country: string;
    countryCode: string;
    carrier: DFCarrier[];
    fixed_charge_frequency: string;
    initial_voucher_charge: string;
  }

  export class DFCarrier {
      id: string;
      carrier_code: string;
      carrier: string;
      status: string;
      asset: DFAsset[];
      fixed_charge_frequency: string;
      initial_voucher_charge: string;
  }

export class DFAsset {
    id: string;
    asset_id: string;
    asset_type: string;
    asset_name: string;
    license_number: string;
    address: string;
    status: string
}
